<template>
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000247')"
					:inputValue="plantCd_"
					:options="plants_"
					:onChange="value => onChange({ key: 'plantCd', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000248')"
					:inputValue="shopCd_"
					:options="shopCds_"
					:onChange="value => onChange({ key: 'shopCd', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000249')"
					:inputValue="serverName_"
					:options="serverNames_"
					:onChange="value => onChange({ key: 'serverName', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000250')"
					:inputValue="serviceKind_"
					:options="serviceKinds_"
					:onChange="value => onChange({ key: 'serviceKind', value })"
				/>
			</el-col>
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000251')"
					:inputValue="pgmType_"
					:options="pgmTypes_"
					:onChange="value => onChange({ key: 'pgmType', value })"
				/>
			</el-col>
			<el-col :span="4">
				<!-- <sf-select-group
					:label="getMessage_('SWCC000255')"
					:inputValue="pgmId_"
					:options="pgmIds_"
					:onChange="value => onChange({ key: 'pgmId', value })"
				/> -->
				<sf-input-group :label="getMessage_('SWCC000255')" :inputValue="pgmId_" :onChange="value => onChange({ key: 'pgmId', value })" />
			</el-col>
		</el-row>
		<template slot="button">
			<sf-button v-if="isButton_(scrId, 'CR')" line :onClick="findAllPrograms"
				><i class="icon-sf-search"></i>{{ getMessage_('SWCC000244') }}</sf-button
			>
		</template>
	</sf-search-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/ProgramRegistration/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onChange({ key, value }) {
			this.DEFAULT_ASSIGN({
				key: 'searchParams',
				value: {
					...this.searchParams,
					[key]: value
				}
			});
		},
		async findAllPrograms() {
			this.$sf_toggleLoading(true);
			this.fetchPrograms_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ })
				.then(() => this.fetchPgmIds_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }))
				.finally(() => this.$sf_toggleLoading(false));
		}
	},
	created() {
		this.$sf_toggleLoading(true);
		this.fetchPlants_()
			.then(() => this.fetchShopCds_({ plantCd: this.user.plantCd }))
			.then(() => this.fetchServiceKinds_({ plantCd: this.user.plantCd }))
			.then(() => this.fetchPgmTypes_({ plantCd: this.user.plantCd }))
			.then(() => this.fetchPgmIds_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ }))
			.then(() => this.DEFAULT_ASSIGN({ key: 'searchParams', value: { ...this.searchParams, plantCd: this.user.plantCd } }))
			.finally(() => this.$sf_toggleLoading(false));
	},
	watch: {
		// TODO
		shopCd_() {
			this.findAllPrograms();
		},
		serviceKind_() {
			this.findAllPrograms();
		},
		pgmType_() {
			this.findAllPrograms();
		},
		pgmId_() {
			this.findAllPrograms();
		}
	}
};
</script>

<style langType="scss"></style>
